'use client';
import { useEffect, useState } from 'react';
import PostStack from './post-stack';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setPostStackData } from '@/redux/slices/post-stack/postStackSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflinePostStackProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflinePostStack({ projectId, isOffline }: OfflinePostStackProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadPostStackData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);
          
          if (project?.postStackData) {
            dispatch(setPostStackData(project.postStackData));
          }
        } catch (error) {
          console.error('Error loading post-stack data:', error);
          showErrorToast('Failed to load post-stack configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadPostStackData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          postStackData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Post-stack data saved offline");
      }
    } catch (error) {
      console.error('Error saving post-stack data:', error);
      showErrorToast("Failed to save post-stack data");
    }
  };

  if (isLoading) {
    return <div>Loading post-stack configuration...</div>;
  }

  return (
    <PostStack 
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
} 